import { render, staticRenderFns } from "./CloseAllTransportsDialog.vue?vue&type=template&id=4bc777bd"
import script from "./CloseAllTransportsDialog.vue?vue&type=script&lang=ts"
export * from "./CloseAllTransportsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports